import { gql, useMutation } from '@apollo/client';
import { Button } from '@mui/joy';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showMessage } from '../../store/snackbar-slice';

const verifyBedSensorSettingsMutation = gql`
  mutation VerifyBedSensorSettings($_id: ID!) {
    verifyBedSensorSettings(_id: $_id)
  }
`;

interface Props {
  _id: string;
}

function VerifySettingsButton({ _id }: Props) {
  const [verifySettings] = useMutation(verifyBedSensorSettingsMutation);
  const [saving, setSaving] = useState(false);
  const dispatch = useDispatch();

  const onClick = useCallback(async () => {
    setSaving(true);
    try {
      await verifySettings({ variables: { _id } });
      dispatch(
        showMessage({
          _id: 'verify-bed-sensor-settings',
          severity: 'success',
          message: 'Success',
        }),
      );
    } catch (err: any) {
      console.error(err);
      dispatch(
        showMessage({
          _id: 'verify-bed-sensor-settings',
          severity: 'danger',
          message: 'There was an error verifying settings.',
        }),
      );
    }
    setSaving(false);
  }, [verifySettings, dispatch, _id]);

  return (
    <Button
      loading={saving}
      onClick={onClick}
      variant="outlined"
      size="sm"
      sx={{ ml: 1 }}
    >
      Verify Settings
    </Button>
  );
}

export default VerifySettingsButton;
